module.exports = __webpack_public_path__ + "img/main_background.cb46bf9b.jpg";